<ngb-alert [hidden]="!show" [type]="'warning'" (closed)="onDismissed()">
  {{ content }} <a class="alert-link" (click)="onCtaClicked()">{{ ctaText }}</a>
</ngb-alert>
